export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["Approved"] = "Approved";
    ApprovalStatus["Pending"] = "Pending";
    ApprovalStatus["Rejected"] = "Rejected";
    ApprovalStatus["Edited"] = "Edited";
})(ApprovalStatus || (ApprovalStatus = {}));
